import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';

import RecipeSessionContainer from './RecipeSessionContainer';
import DetailHeader from '../../components/generics/DetailHeader';
import AddIngredient from '../../components/sessions/ProdAddIngredient';
import ListIngredients from '../../components/sessions/ProdListIngredients';
import ListLeftovers from '../../components/sessions/ListLeftovers';
import AddProduct from '../../components/sessions/ProdAddProduct';
import ListProducts from '../../components/sessions/ListProducts';
import Spinner from '../../components/generics/Spinner';
import Modal from '../../components/generics/Modal';
import ListProductionIntermediateLabels from '../../components/sessions/ListProductionIntermediateLabels';

import {SCAN_SCANNING, SCAN_OK, SCAN_ERROR} from '../../components/generics/QRScanner';
import { get } from "../../utils/axiosInstance";

import { showErrors } from '../../utils/Helpers';
import Alert from '../../utils/Alert';

import {
  cleanSession,
  fetchSession,
  fetchSessionSuccess,
  fetchSessionFailure,
  addIngredient,
  addIngredientSuccess,
  addIngredientFailure,
  deleteIngredient,
  deleteIngredientSuccess,
  deleteIngredientFailure,
  addProduct,
  addProductSuccess,
  addProductFailure,
  deleteProduct,
  deleteProductSuccess,
  deleteProductFailure,
  updateProduct,
  updateProductSuccess,
  updateProductFailure,
  updateIngredient,
  updateIngredientSuccess,
  updateIngredientFailure,
  updateProdSession,
  updateProdSessionSuccess,
  updateProdSessionFailure,
  updateLeftover,
  updateLeftoverSuccess,
  updateLeftoverFailure,
} from "../../store/sessions/actions";

import { finishSession } from "../../store/sessions/api";
import { withRouter } from "utils/WithRouter";


export class SessionContainer extends Component {
  // ---------------------------------------------------------------------------
  // Initialization
  // ---------------------------------------------------------------------------
  constructor(props) {
    super(props);
    this.alertRef = React.createRef();

    this.state = {
      inventoryId: '',
      loadingInventory: false,
      inventoryDetail: undefined,
      inventoryError: false,
      disableAmountInput: false,
      isSubmittingItems: false,
      ingredients: [],
      leftovers: [],
      leftoverError: [],
      leftoverWarning: [],
      productItemId: 0,
      productItem: undefined,
      pieces: '',
      times: 1,
      productAmount: '',
      productItemError: [],
      products: [],
      isSubmittingProductItems: false,
      productError: [],
      piecesProductError: [],
      listIngredientsError: {},
      missingIngridientsError: {},
      isClear: true,
      preselectedProduct: undefined,
      can_produce: [],
      scannedItems: [],
      scanResult: '',
      scanStatus: SCAN_SCANNING,
      scannedId: undefined,
      scannedItem: undefined,
      inventoryToAdd: '',
      isOpenPrintLabelsModal: false,
      isOpenFinishSessionModal: false,
    }
  }

  componentDidMount() {
    this.props.fetchSession(this.props.match.params.id);
  }

  componentWillUnmount() {
    this.props.cleanSession();
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.props.sessionDetail.loading && prevProps.sessionDetail.loading) {
      if (this.props.sessionDetail.session && this.props.sessionDetail.session.is_finished) {
        this.props.history.push('/session/' + this.props.match.params.id);
      } else {
        const ingredients = this.props.sessionDetail.session.temporary_ingredients || [];
        const leftovers = this.props.sessionDetail.session.temporary_leftovers || [];
        const products = this.props.sessionDetail.session.temporary_products || [];
        const isLoading = this.props.sessionDetail.loading;
        let can_produce = this.props.sessionDetail.session.can_produce;
        this.setState({ ingredients, leftovers, products, can_produce, isLoading});
      }
    }

    if (this.props.sessionDetail.error && this.props.sessionDetail.error !== prevProps.sessionDetail.error){
      if (prevState.scanStatus === SCAN_OK){
        this.setState({
          scanResult: `Cannot add scanned Inventory`,
          scanStatus: SCAN_ERROR
        });
      } else {
        this.alertRef.current.sendAlert(this.props.sessionDetail.error)
      }
    }
  }

  hasError = () => {
    //listIngredientsError error on the amount of one of the selected ingredients
    //leftoverError error on the amount of one of the leftovers
    //productError error on the amount of one of the products
    //piecesProductError error on the pieces of one of the products
    return !(
      (_.size(this.state.listIngredientsError) === 0) && (this.state.leftoverError.length === 0)
      && (this.state.productError.length === 0) && (this.state.piecesProductError.length === 0))
  };

  hasOnlyOneError = (error) => {
    switch (error) {
      case 'listIngredientsError': // no error except listIngredientsError
        return (
          (this.state.leftoverError.length === 0) && (this.state.productError.length === 0)
          && (this.state.piecesProductError.length === 0))
      case 'leftoverError':
        return (
          (_.size(this.state.listIngredientsError) === 0) && (this.state.productError.length === 0)
          && (this.state.piecesProductError.length === 0))
      case 'productError':
        return (
          (_.size(this.state.listIngredientsError) === 0) && (this.state.leftoverError.length === 0)
          && (this.state.piecesProductError.length === 0))
      case 'piecesProductError':
        return (
          (_.size(this.state.listIngredientsError) === 0) && (this.state.leftoverError.length === 0)
          && (this.state.productError.length === 0))
    }
  };

  arrayObjectIndexOf = (myArray, searchTerm, property) => {
    for(var i = 0, len = myArray.length; i < len; i++) {
      if (myArray[i][property] === searchTerm) return i;
    }
    return -1;
  };

  spliceError = (element, array) => {
    var errors = array.slice();
    var index = errors.indexOf(element);
    if(index !== -1){
      errors.splice(index, 1)
    }
    return errors
  };

  removeErrors = (element, errors) => {
    let newErrors = Object.assign({}, errors)
    delete newErrors[element]
    return newErrors
  };


////////////////////////////////////////////////////////////
///////////////////// ListIngredients /////////////////////
//////////////////////////////////////////////////////////

  handleIngredientAmountChange = (event,index) => {
    let listChangeAmountError = this.state.listIngredientsError;
    //The user can only edit an ingredient when there is no error or the only error is on the ingredient they want to edit
    if(!this.hasError() || (this.hasOnlyOneError('listIngredientsError') && (index in listChangeAmountError))){
      let ingredients = this.state.ingredients.slice();
      ingredients[index].amount = event.target.value;
      var listIngredientsError = this.removeErrors(index,this.state.listIngredientsError);
      this.setState({ ingredients, listIngredientsError });
    }else{
      this.alertRef.current.sendAlert('Please correct the error to continue.');
    }
  };

  handleOnBlur = (index) => {
    var ingredients = this.state.ingredients.slice();
    var listIngredientsError = this.removeErrors(index, this.state.listIngredientsError);

    if(ingredients[index].amount !== ''){
      if (ingredients[index].amount <= 0) {
        listIngredientsError[index] = []
        listIngredientsError[index].push('incorrect value')
        this.setState({listIngredientsError})
        this.alertRef.current.sendAlert("Please correct the amount of the ingredient. It should be greater than 0.");
      } else if (!this.hasError()) {
        this.props.updateIngredient(
          this.props.match.params.id,
          ingredients[index].id,
          ingredients[index].amount
        )
      }
    }else{
      listIngredientsError[index] = []
      listIngredientsError[index].push('required')
      this.setState({listIngredientsError})
      this.alertRef.current.sendAlert('Please correct the amount of the ingredient.');
    }
  };

  handleIngredientDelete = (index) => {
    let listChangeAmountError = this.state.listIngredientsError;
    //The user can only delete an ingredient when there is no error or the only error is on the ingredient they want to delete
    if(!this.hasError() || (this.hasOnlyOneError('listIngredientsError') && (index in listChangeAmountError))){
      var listIngredientsError = this.removeErrors(index,this.state.listIngredientsError);
      this.setState({ listIngredientsError });
      this.props.deleteIngredient(
        this.props.match.params.id,
        this.state.ingredients[index].id,
      )
    }else{
      this.alertRef.current.sendAlert('Please correct the error to continue.');
    }
  };

////////////////////////////////////////////////////////////
////////////////////// ListLeftovers //////////////////////
//////////////////////////////////////////////////////////

  toggleCheckBox = (event) => {
    let leftoverError = this.state.leftoverError;
    //The user can only edit a leftover when there is no error or the only error is on the ingredient they want to edit
    let index = this.arrayObjectIndexOf(this.state.leftovers, parseInt(event.target.value, 10), "id");
    if(!this.hasError() || (this.hasOnlyOneError('leftoverError') && (leftoverError.indexOf(index) !== -1))){
      let leftovers = this.state.leftovers.slice();
      leftovers[index].has_leftover = !leftovers[index].has_leftover;
      if(!leftovers[index].has_leftover){
        let leftoverError = this.spliceError(index,this.state.leftoverError);
        leftovers[index].amount = '';
        this.setState({ leftoverError });
      }
      if (index === 0 && this.state.leftoverWarning.length > 0 && !leftovers[index].has_leftover) {
        this.setState({leftoverWarning: []});
      }
      this.props.updateLeftover(
        this.props.match.params.id,
        this.state.leftovers[index].id,
        this.state.leftovers[index].has_leftover)
    }else{
      this.alertRef.current.sendAlert('Please correct the error to continue.');
    }
  };

  handleLeftoverAmountChange = (event,index) => {
    let leftoverError = this.state.leftoverError;
    //The user can only edit a leftover when there is no error or the only error is on the ingredient they want to edit
    if(!this.hasError() || (this.hasOnlyOneError('leftoverError') && (leftoverError.indexOf(index) !== -1))){
      let leftovers = this.state.leftovers.slice();
      leftovers[index].amount = event.target.value;
      let leftoverError = this.spliceError(index,this.state.leftoverError);
      if (index === 0 && this.state.leftoverWarning.length > 0 && leftovers[index].amount > 0) {
        this.setState({ leftoverWarning: [] });
      }
      this.setState({ leftovers, leftoverError });
    }else{
      this.alertRef.current.sendAlert('Please correct the error to continue.');
    }
  };

  handleOnAmountBlur = (index) => {
    var leftovers = this.state.leftovers.slice();
    if(leftovers[index].amount !== ''){
      if(!this.hasError()){
        if(leftovers[index].amount < leftovers[index].original_amount &&
          // Adding 0,0001 to fix round representation
          (Math.round((Math.abs(leftovers[index].amount - leftovers[index].original_amount) + 0.0001) * 100) / 100) >= 0.01){
          this.props.updateLeftover(
            this.props.match.params.id,
            this.state.leftovers[index].id,
            this.state.leftovers[index].has_leftover,
            this.state.leftovers[index].amount)
        }else{
          let listError = this.state.leftoverError.slice()
          let leftoverError = this.spliceError(index,listError);
          leftoverError.push(index)
          this.setState({leftoverError})
          this.alertRef.current.sendAlert('The amount leftover must be less than the original amount');
        }
      }
    }else{
      let listError = this.state.leftoverError.slice()
      let leftoverError = this.spliceError(index,listError);
      leftoverError.push(index)
      this.setState({leftoverError})
      this.alertRef.current.sendAlert('Please correct the amount of the leftover.');
    }
  };

////////////////////////////////////////////////////////////
///////////////////// Produced items /////////////////////
//////////////////////////////////////////////////////////

  handleProductItemChange = (event) => {
    let item_index = this.arrayObjectIndexOf(this.state.can_produce, parseInt(event.target.value, 10), "id");
    if(item_index !== -1){
      let item = this.state.can_produce[item_index],
          pieces = item.master_packing_number || '',
          productAmount = item.default_item_weight || '',
          disableProductAmountInput = item.default_item_weight,
          disableProductPiecesInput = item.default_item_weight && !item.is_individual_weight && item.master_packing_number,
          productItemError = this.spliceError('item',this.state.productItemError);

      if(item.is_individual_weight){
        productAmount = this.calculateProductWeight(item, pieces)
      }

      if (productAmount) { productItemError = this.spliceError('amount', productItemError); }
      if (pieces) { productItemError = this.spliceError('pieces', productItemError); }

      this.setState({productItemId:item.id, productItem: item, productItemError, pieces, productAmount,
        disableProductAmountInput, disableProductPiecesInput});
    }else{
      this.setState({productItemId:0, productItem: undefined, pieces: '', productAmount: ''});
    }

  };

  handleProductAmountChange = (event) => {
    let productItemError = this.spliceError('amount',this.state.productItemError);
    this.setState({productAmount:event.target.value, productItemError});
  };

  calculateProductWeight = (item, pieces) => {
    if (pieces !== "" && item.default_item_weight) {
      return (item.default_item_weight * pieces).toFixed(2);
    } else {
      return "";
    }
  };

  handleProductPiecesChange = (event) => {
    let productItemError = this.spliceError('pieces',this.state.productItemError);
    productItemError = this.spliceError('packs',productItemError);
    let item = this.state.productItem;

    if(item && item.is_individual_weight){
      productItemError = this.spliceError('amount', productItemError);
      let productAmount = this.calculateProductWeight(item, event.target.value)
      this.setState({pieces:event.target.value, productItemError, productAmount});
    } else {
      this.setState({pieces:event.target.value, productItemError});
    }
  };

  handleProductClear = () => {
    this.setState({productItemId:0, productItem:undefined, isClear:true, pieces: '', productAmount: ''});
  };

  handleAddProductItem = () => {
    //The user can only add a product when there is no error
    if(!this.hasError()){
      this.setState({ isSubmittingProductItems: true });
      if(
        this.state.productAmount !== ''
        && this.state.productAmount > 0
        && this.state.productItemId !== 0
        && this.state.pieces !== ''
        && this.state.pieces > 0
        && this.state.times !== ''
        && this.state.times > 0
      ){
        this.props.addProduct(
          this.props.match.params.id,
          this.state.productItem.id,
          this.state.productAmount,
          this.state.pieces,
          this.state.times)
      }else{
        let productItemError = this.state.productItemError;
        if(this.state.productAmount === '' || this.state.productAmount <= 0){
          productItemError = this.spliceError('amount',productItemError);
          productItemError.push('amount');
        }
        if(this.state.productItemId === 0){
          productItemError = this.spliceError('item',productItemError);
          productItemError.push('item');
        }
        if(this.state.pieces === '' || this.state.pieces <= 0){
          productItemError = this.spliceError('pieces',productItemError);
          productItemError.push('pieces');
        }
        this.alertRef.current.sendAlert('All fields are required!')
        this.setState({
          isSubmittingProductItems: false,
          productItemError
        });
      }
    }else{
      this.alertRef.current.sendAlert('Please correct the error to continue.');
    }
  };

  handleOnTimesChange = (event) => {
    let times = event.target.value
    this.setState({times})
  };

////////////////////////////////////////////////////////////
/////////////////// List Producted items //////////////////
//////////////////////////////////////////////////////////
  handleListProductAmountChange = (event, index) => {
    let errors = this.state.productError;
    //The user can only edit a product when there is no error on the number of pieces and there ir no error on the amount or the only error is on the product they want to edit
    if(!this.hasError() || (this.hasOnlyOneError('productError') && (errors.indexOf(index) !== -1))){
      let products = this.state.products.slice();
      products[index].amount = event.target.value;
      let productError = this.spliceError(index,this.state.productError);
      this.setState({ products, productError });
    } else {
      this.alertRef.current.sendAlert('Please correct the error to continue.');
    }
  };

  handleOnProductAmountBlur = (index, fromScale) => {
    var products = this.state.products.slice();
    if (fromScale) {
      get(`${process.env.REACT_APP_SCALE_SERVER_HOST}/kitchen/`)
      .then(response => {
        if ('weight' in response.data) {
          products[index].amount = response.data['weight']
          this.handleUpdateProductAmount(index)
        }
      })
      .catch(error => {
        this.alertRef.current.sendAlert('Is not possible read value from the scale');
      })
    } else {
      this.handleUpdateProductAmount(index)
    }
  };

  handleUpdateProductAmount(index) {
    var products = this.state.products;
    if(products[index].amount !== '' && products[index].amount > 0){
      if(!this.hasError()){
        this.props.updateProduct(
          this.props.match.params.id,
          this.state.products[index].id,
          this.state.products[index].amount,
          this.state.products[index].pieces)
      }
    } else {
      let listError = this.state.productError.slice();
      let productError = this.spliceError(index,listError);
      productError.push(index)
      this.setState({productError});
      this.alertRef.current.sendAlert('Please correct the amount of the product.');
    }
  };

  handlePiecesChange = (event, index) => {
    let errors = this.state.piecesProductError;
    //The user can only edit the product when there is no error on the amount and there is no error on the pieces or the only error is on the product they want to edit
    if(!this.hasError() || (this.hasOnlyOneError('piecesProductError') && (errors.indexOf(index) !== -1))){
      let products = this.state.products.slice();
      products[index].pieces = event.target.value;
      let piecesProductError = this.spliceError(index,this.state.piecesProductError);
      if(products[index].item.is_individual_weight){
        let productAmount = this.calculateProductWeight(products[index].item, event.target.value)
        products[index].amount = productAmount
      }
      this.setState({ products, piecesProductError });
    }else{
      this.alertRef.current.sendAlert('Please correct the error to continue.');
    }
  };

  handlePiecesBlur = (index) => {
    var products = this.state.products.slice();
    if(products[index].pieces !== '' && products[index].pieces > 0){
      if(!this.hasError()){
        this.props.updateProduct(
          this.props.match.params.id,
          this.state.products[index].id,
          this.state.products[index].amount,
          this.state.products[index].pieces)
      }
    }else{
      let listError = this.state.piecesProductError.slice();
      let piecesProductError = this.spliceError(index,listError);
      piecesProductError.push(index)
      this.setState({piecesProductError})
      this.alertRef.current.sendAlert('Please correct the pieces of the product.');
    }
  };

  handleProductDelete = (index) => {
    let listProductError = this.state.productError;
    let errors = this.state.piecesProductError;
    //The user can only delete an ingredient when there is no error or the only error is on the ingredient they want to delete
    if(!this.hasError() || (this.hasOnlyOneError('piecesProductError') && (errors.indexOf(index) !== -1))
    || (this.hasOnlyOneError('productError') && (listProductError.indexOf(index) !== -1))){
      var productError = this.spliceError(index,this.state.productError);
      var piecesProductError = this.spliceError(index,this.state.piecesProductError);
      this.setState({ productError, piecesProductError });
      this.props.deleteProduct(this.props.match.params.id, this.state.products[index].id)
    }else{
      this.alertRef.current.sendAlert('Please correct the error to continue.');
    }
  };

  // ---------------------------------------------------------------------------
  // Add Inventory by ID (Inventory Control)
  // ---------------------------------------------------------------------------
  onInventoryToAddChange = (event) => {
    this.setState({ inventoryToAdd: event.target.value });
  };

  onInventoryAddSubmit = () => {
    const productionSessionId = this.props.match.params.id;
    const inventoryId = this.state.inventoryToAdd;

    if (this.inventoryAlreadyInIngredients(inventoryId)){
      this.alertRef.current.sendAlert(`Inventory #${inventoryId} already added.`);
      return;
    }

    this.setState({ loadingIngredient: true }, () => {
      this.props.addIngredient(productionSessionId, inventoryId)
      this.setState({
        inventoryToAdd: '',
        loadingIngredient: false,
      })
    });
  };

  handleScannedInventory = (scan, format) => {
    const scannedInventoryId = scan;
    const productionSessionId = this.props.match.params.id;
    this.props.addIngredient(productionSessionId, scannedInventoryId, format)
  };

  handleScanError = () => {
    this.setState({scanStatus: SCAN_ERROR, scanResult: 'Cannot scan'});
  };

  cleanMessage = () => {
    this.setState({scanStatus: SCAN_SCANNING, scanResult: ''});
  };

  // ---------------------------------------------------------------------------
  // Session Handling
  // ---------------------------------------------------------------------------

  openFinishSessionModal = () => {
    this.setState({isOpenFinishSessionModal: true});
  };

  onFinishSession = () => {
    if (!this.hasError()){
      const sessionID = this.props.match.params.id;
      if (this.state.products.length === 0 && !this.props.sessionDetail.session.intermediate_labels){
        this.alertRef.current.sendAlert("Cannot finish a session without products");
        return;
      }
      if (this.props.sessionDetail.session.station.name === 'Butcher' && this.weightDifferences()) {
        this.alertRef.current.sendAlert(
          "Warning: You didn't use all ingredients weight",
          "warning");
      }
      finishSession(sessionID).then((r) => {
        this.props.history.push('/session/' + sessionID + '/labels?finish_session=true');
      }).catch((error) => {
        if (error.response.status === 400 && 'missing_ingredients' in error.response.data) {
          this.setState({missingIngridientsError: error.response.data.missing_ingredients})
        } else {
          showErrors(error, this.alertRef);
        }
        this.setState({isOpenFinishSessionModal: false})
      });
    } else {
      this.alertRef.current.sendAlert('Please correct the errors to continue.');
    }
  };

  // ---------------------------------------------------------------------------
  // Utils
  // ---------------------------------------------------------------------------
  weightDifferences = () => {
    let ingredientsWeight = 0,
        childrenWeight = 0;
    _.each(this.state.ingredients, (ingredient) => {
      ingredientsWeight += ingredient.weight
    })
    _.each(this.state.products, (product) => {
      childrenWeight += parseFloat(product.amount) * parseFloat(product.pieces)
    })
    _.each(this.state.leftovers, (leftover) => {
      if (leftover.has_leftover) {
        childrenWeight += parseFloat(leftover.amount)
      }
    })
    _.each(this.props.sessionDetail.session.printed_items, (inventory) => {
      childrenWeight += parseFloat(inventory.weight) * parseFloat(inventory.number_items)
    })
    return ingredientsWeight > childrenWeight
  };

  inventoryAlreadyInIngredients = (inventoryId) => {
    return _.find(this.state.ingredients, function(obj) {
      return obj.id === parseInt(inventoryId, 10);
    });
  };

  printIntermediateLabels = () => {
    if (!this.props.sessionDetail.session.intermediate_labels) {
      this.setState({isOpenPrintLabelsModal:true});
    } else {
      this.createIntermediateLabels();
    }
  };

  createIntermediateLabels = () => {
    this.props.history.push('/session/' + this.props.match.params.id + '/intermediate_labels/');
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render() {
    if(!this.props.sessionDetail.session || this.props.sessionDetail.session.loading){
      return <Spinner />
    } else if (this.props.sessionDetail.session.recipe && !this.props.sessionDetail.session.recipe.final_product){
      return(
        <div>
          <Alert ref={this.alertRef}/>
          <RecipeSessionContainer
            session={this.props.sessionDetail.session}
            history={this.props.history}
            updateProdSession={this.props.updateProdSession}
            onIngredientDelete={this.handleIngredientDelete}
            ingredients={this.state.ingredients}
            leftovers={this.state.leftovers}
            inventoryToAdd={this.state.inventoryToAdd}
            onInventoryToAddChange={this.onInventoryToAddChange}
            onInventoryAddSubmit={this.onInventoryAddSubmit}
            onScannedInventory={this.handleScannedInventory}
            scanResult={this.state.scanResult}
            scanStatus={this.state.scanStatus}
            loadingIngredient={this.state.loadingIngredient}
            listIngredientsError={this.state.listIngredientsError}
            onIngredientAmountChange={this.handleIngredientAmountChange}
            onIngredientAmountBlur={this.handleOnBlur}
            onScanError={this.handleScanError}
            onLeftoverAmountChange={this.handleLeftoverAmountChange}
            onLeftoverAmountBlur={this.handleOnAmountBlur}
            onLeftoverToggleCheckBox={this.toggleCheckBox}
            leftoverError={this.state.leftoverError}
            leftoverWarning={this.state.leftoverWarning}
            hasError={this.hasError}
            />
        </div>
      )
    } else {
      return (
        <div>
          <Alert ref={this.alertRef}/>
          <DetailHeader title="Production Session"
                        actionTitle="Finish"
                        action ={this.openFinishSessionModal}
                        actionClass="btn btn-success m-0"
                        actionIconClass="fa fa-check mr-05"

                        action2Available={this.state.products.length >0 && this.state.ingredients.length >0}
                        action2Title="Labels"
                        action2 ={this.printIntermediateLabels}
                        action2Class="btn btn-primary m-0 mr-05"
                        action2IconClass="fa fa-print mr-05"

                        col1Title="Session Number"
                        col1Desc={this.props.sessionDetail.session.id}
                        col2Title="Date"
                        col2Desc={moment(this.props.sessionDetail.session.date_created).format('LLL')}
                        col3Title="Station"
                        col3Desc={this.props.sessionDetail.session.station.name}

                        appendWarningMessage={this.props.sessionDetail.session.intermediate_labels}
                        warningMessage={`You can't add or remove ingredients, because you have already printed products labels.`}/>
          <Modal
            closeModal={() => this.setState({isOpenPrintLabelsModal: false})}
            isModalOpen={this.state.isOpenPrintLabelsModal}
            onConfirm={this.createIntermediateLabels}
            onCancel={() => this.setState({isOpenPrintLabelsModal: false})}
            header="Warning"
            content={`Current production session is not finished yet, if you print labels now, you won't be able to add or remove ingredients.\n
                      Would you like to continue anyway?`}
            textInput = {false}
            onConfirmButtonText="Continue"
            onCancelButtonText="Cancel"
          />
          <Modal
            closeModal={() => this.setState({isOpenFinishSessionModal: false})}
            isModalOpen={this.state.isOpenFinishSessionModal}
            onConfirm={this.onFinishSession}
            onCancel={() => this.setState({isOpenFinishSessionModal: false})}
            header="Warning"
            content={`Are you sure you want to finish this session?`}
            textInput = {false}
            onConfirmButtonText="Finish"
            onCancelButtonText="Cancel"
          />
          {this.state.missingIngridientsError.length &&
          <div className='card'>
            <div className="card-header alert-danger">
              <h5>Some ingredients are missing to be able to end the session:</h5>
              {this.state.missingIngridientsError.map((item, index) => <li key={index}>{`${item.name}: ${item.value} ${item.unit_of_measure}`}</li>)}
            </div>
          </div>}
          <div className="row">
            <div className="col-lg-12 col-xl-6">
              {/* If session has intermediate_labels, session ingredients can't be modified */}
              {this.props.sessionDetail.session.intermediate_labels ? null :
                <AddIngredient
                  title="Ingredients"
                  ingredientBarCodeInput={this.state.inventoryToAdd}
                  onInventoryToAddChange={this.onInventoryToAddChange}
                  onInventoryAddSubmit={this.onInventoryAddSubmit}
                  handleScannedInventory={this.handleScannedInventory}
                  handleScanError={this.handleScanError}
                  scanResult={this.state.scanResult}
                  scanStatus={this.state.scanStatus}
                />
              }
              <ListIngredients
                title="Selected Ingredients"
                ingredients={this.state.ingredients}
                onIngredientAmountChange={this.handleIngredientAmountChange}
                onBlur={this.handleOnBlur}
                changeAmountError={this.state.listIngredientsError}
                onIngredientDelete={this.handleIngredientDelete}
                intermediateLabels={this.props.sessionDetail.session.intermediate_labels}
                isLoading={this.state.isLoading}
              />
              <ListLeftovers
                title="Leftovers"
                leftovers={this.state.leftovers}
                toggleCheckBox={this.toggleCheckBox}
                onLeftoverAmountChange={this.handleLeftoverAmountChange}
                leftoverError={this.state.leftoverError}
                leftoverWarning={this.state.leftoverWarning}
                onAmountBlur={this.handleOnAmountBlur}
              />
            </div>
            <div className="col-lg-12 col-xl-6">
              <AddProduct
                title="Products"
                items={this.state.can_produce}
                onItemChange={this.handleProductItemChange}
                itemIndex={this.state.productItemIndex}
                item={this.state.productItem}
                amount={this.state.productAmount}
                onAmountChange={this.handleProductAmountChange}
                onAddItem={this.handleAddProductItem}
                isSubmittingItems={this.props.sessionDetail.loading}
                errors={this.state.productItemError}
                hasPieces={true}
                onPiecesChange={this.handleProductPiecesChange}
                pieces={this.state.pieces}
                disableAmountInput={this.state.disableProductAmountInput}
                disablePiecesInput={this.state.disableProductPiecesInput}
                isClear={this.state.isClear}
                onClear={this.handleProductClear}
                preselectedProduct={this.state.preselectedProduct}
                onTimesChange={this.handleOnTimesChange}
                times={this.state.times}
              />
              <ListProducts
                title="Produced"
                products={this.state.products}
                onAmountChange={this.handleListProductAmountChange}
                productError={this.state.productError}
                onAmountBlur={this.handleOnProductAmountBlur}
                onProductDelete={this.handleProductDelete}
                onPiecesChange={this.handlePiecesChange}
                onPiecesBlur={this.handlePiecesBlur}
                piecesProductError={this.state.piecesProductError}
              />
              {this.props.sessionDetail.session.intermediate_labels ?
                <ListProductionIntermediateLabels
                  title="Already Printed"
                  intermediate_labels={this.props.sessionDetail.session.printed_items} />
              : null }
            </div>
          </div>
          <DetailHeader title=""
                        actionTitle="Finish"
                        action ={this.onFinishSession}
                        actionClass="btn btn-success m-0"
                        actionIconClass="fa fa-check mr-05"
                        onlyHeader={true} />
        </div>
      );
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    sessionDetail: state.sessions.sessionDetail
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchSession: (sId) => {
      dispatch(fetchSession(sId)).payload.then((response) => {
        dispatch(fetchSessionSuccess(response.data))
      }, (error) => {
        dispatch(fetchSessionFailure(error));
      });
    },
    updateProdSession: (sId, data) => {
      dispatch(updateProdSession(sId, data)).payload.then((response) => {
        dispatch(updateProdSessionSuccess(response.data))
      }, (error) => {
        dispatch(updateProdSessionFailure(error));
      });
    },
    addIngredient: (sId, code, format) => {
      dispatch(addIngredient(sId, code, format)).payload.then((response) => {
        dispatch(addIngredientSuccess(response.data))
      }, (error) => {
        dispatch(addIngredientFailure(error));
      });
    },
    updateIngredient: (sId, infoId, amount) => {
      dispatch(updateIngredient(sId, infoId, amount)).payload.then((response) => {
        dispatch(updateIngredientSuccess(response.data))
      }, (error) => {
        dispatch(updateIngredientFailure(error));
      });
    },
    deleteIngredient: (sId, info_id) => {
      dispatch(deleteIngredient(sId, info_id)).payload.then((response) => {
        dispatch(deleteIngredientSuccess(response.data))
      }, (error) => {
        dispatch(deleteIngredientFailure(error));
      });
    },
    deleteProduct: (sId, info_id) => {
      dispatch(deleteProduct(sId, info_id)).payload.then((response) => {
        dispatch(deleteProductSuccess(response.data))
      }, (error) => {
        dispatch(deleteProductFailure(error));
      });
    },
    addProduct: (sId, itemId, amount, pieces, times) => {
      dispatch(addProduct(sId, itemId, amount, pieces, times)).payload.then((response) => {
        dispatch(addProductSuccess(response.data))
      }, (error) => {
        dispatch(addProductFailure(error));
      });
    },
    updateProduct: (sId, infoId, amount, pieces) => {
      dispatch(updateProduct(sId, infoId, amount, pieces)).payload.then((response) => {
        dispatch(updateProductSuccess(response.data))
      }, (error) => {
        dispatch(updateProductFailure(error));
      });
    },
    updateLeftover: (sId, infoId, hasLeftover, amount) => {
      dispatch(updateLeftover(sId, infoId, hasLeftover, amount)).payload.then((response) => {
        dispatch(updateLeftoverSuccess(response.data))
      }, (error) => {
        dispatch(updateLeftoverFailure(error));
      });
    },
    cleanSession: (sId) => {
      dispatch(cleanSession())
    }
  };
};

export default connect(mapStateToProps,mapDispatchToProps)(withRouter(SessionContainer));
